// TransportHistory Moved to a separate file from TransportHistoriesPopup
import { observer } from "mobx-react-lite";
import { TTransportsHistoryInfo } from "../../../../api/bearer-api";
import { Accordion, AccordionDetails, AccordionSummary, Button } from "@mui/material";
import React from "react";
import { TransportTypeEnum } from "../../../../states/app-state";
import TransportTypeImage from "../../../transport/TransportTypeImage";
import styles from "./transportHistory.module.scss";
import TransportHistoryDetail from "../../TransportHistoryDetail";
import AddressLine from "./addressLine";
import DeliveryPhoto from "./deliveryPhoto";
import { useThemeMode } from "../../../../states/contexts/theme"; // added by Bearer Web Developer
import CancelTooltip from "./cancelTooltip"; // added by Bearer Web Developer

const TransportHistory: React.FC<{ transportsHistory: TTransportsHistoryInfo }> = observer(({ transportsHistory }) => {
    // modified by Bearer Web Developer start
    const price = transportsHistory?.transport_original_price;
    const discounted = transportsHistory?.transport_original_price !== transportsHistory?.transport_receivable_price;
    const free = transportsHistory?.transport_receivable_price === 0; // added by Bearer Web Developer
    const receivablePrice = transportsHistory?.transport_receivable_price; // added by Bearer Web Developer
    const showRealPrice = free || (Number(receivablePrice) < Number(price)); // added by Bearer Web Developer - explanation: free or discounted
    // modified by Bearer Web Developer end
    const time = new Date(transportsHistory.transport_time._seconds * 1000); // modified by Bearer Web Developer
    const completedTransport = transportsHistory.transport_state === 'Completed';
    const canceledByCustomer = transportsHistory.transport_state === 'Canceled by Customer';
    const canceledByRiderForDelay = transportsHistory.transport_state === 'Canceled by Rider for Delay'; // added by Bearer Web Developer
    const transportText = canceledByRiderForDelay ? 'Canceled by Bearer' :  transportsHistory.transport_state; // added by Bearer Web Developer
    const transportImage = Object.values(TransportTypeEnum).find(i => i === transportsHistory.assigned_bearer_type);
    // added by Bearer Web Developer start
    const [expanded, setExpanded] = React.useState<string | false>(false);
    const openHandler = (panel: string) => {
        setExpanded(panel !== expanded ? panel : false);
    };
    // added by Bearer Web Developer end
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start
    return (
        <Accordion expanded={expanded === transportsHistory.transport_id} elevation={0}
            style={{ borderRadius: "10px" }}
            // onChange={() => openHandler(transportsHistory.transport_id)} // commented by Bearer Web Developer
            slotProps={{
                root: {
                    classes: { root: styles.MuiAccordion_root, },
                    style: {
                        background: theme === 'dark' ? '#393939' : '#EDEDED' /* added by Bearer Web Developer */
                    }
                },
            }}
            className={styles.accordion}>
            <AccordionSummary
                slotProps={{
                    content:{
                        className: styles.MuiAccordionSummary_content,
                    },
                    root:{
                        className: styles.MuiAccordionSummary_root,
                    },
                    expandIconWrapper:{
                        className:styles.MuiAccordionSummary_expanded,
                    }
                }}
                component="div"
            >
                <div className={`${styles.transport_main} ${expanded === transportsHistory.transport_id ? styles.open : ''}`} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                    <div className={styles.header}>
                        <p>
                            {theme === "dark" ? <img src="/pin-white.svg" alt="" /> : <img src="/pin.svg" alt="" />}
                            Order Number : {transportsHistory.order_number}
                        </p>
                        <div className={styles.time}>
                            <div>
                                {theme === "dark" ? <img src="/calendar-month-white.svg" alt="date" /> : <img src="/calendar-month.png" alt="date" />}
                                <span>{time.toLocaleDateString()}</span>
                            </div>
                            <div>
                                {theme === "dark" ? <img src="/schedule-white.svg" alt="clock" /> : <img src="/schedule.png" alt="clock" />}
                                <span>{time.toLocaleTimeString()}</span>
                            </div>
                        </div>
                    </div>
                    <div className={styles.line}><hr /></div>
                    <div className={styles.transport}>
                        <div className={styles.transport_image}>
                            <TransportTypeImage type={transportImage!}  />
                        </div>
                        <div className={styles.transport_text}>
                            {
                                !discounted ?
                                    <>
                                        <p className={styles.price}>A$ {price}</p>
                                        {completedTransport &&
                                            <p className={styles.receive_color}>{transportsHistory.transport_state}</p>
                                        }
                                        {/* modified by Bearer Web Developer start */}
                                        {/* canceledByRiderForDelay condition and CancelTooltip added */}
                                        {/* transportsHistory.transport_state value changed to transportText value */}
                                        {(canceledByCustomer || canceledByRiderForDelay) &&
                                            <div className={styles.cancelation}>
                                                <p className={styles.cancel_color}>{transportText}</p>
                                                {transportsHistory?.cancelation_reason && <CancelTooltip text={transportsHistory?.cancelation_reason} />}
                                            </div>
                                        }
                                        {/* modified by Bearer Web Developer end */}
                                    </>
                                    :
                                    <>
                                        {/* modified by Bearer Web Developer start - add showRealPrice and canceledByRiderForDelay conditions */}
                                        <div className={styles.discounted_price}>
                                            {
                                                transportsHistory?.transport_receivable_price === 0 ? // explanation: free - this explanation added by Bearer Web Developer
                                                    <p className={styles.free}>Free!</p> :
                                                    <p className={styles.price_discounted}>
                                                        A$ {transportsHistory?.transport_receivable_price}
                                                        {
                                                            !canceledByCustomer && (
                                                                canceledByRiderForDelay ?
                                                                    <span className={styles.waiting_fee}>Waiting Fee</span> :
                                                                    <span className={styles.discounted}>Discounted</span>
                                                            )
                                                        }
                                                    </p>
                                            }
                                            {showRealPrice && <p className={styles.price_main}>A$ {price}</p>}
                                        </div>
                                        {/* modified by Bearer Web Developer end - add showRealPrice and canceledByRiderForDelay conditions */}
                                        {completedTransport &&
                                            <p className={styles.receive_color} >{transportsHistory.transport_state}</p>
                                        }
                                        {/* modified by Bearer Web Developer start */}
                                        {/* canceledByRiderForDelay condition and CancelTooltip added */}
                                        {/* transportsHistory.transport_state value changed to transportText value */}
                                        {(canceledByCustomer || canceledByRiderForDelay) &&
                                            <div className={styles.cancelation}>
                                                <p className={styles.cancel_color}>{transportText}</p>
                                                {transportsHistory?.cancelation_reason && <CancelTooltip text={transportsHistory?.cancelation_reason} />}
                                            </div>
                                        }
                                        {/* modified by Bearer Web Developer end */}
                                    </>
                            }
                            {
                                transportsHistory?.proof_of_delivery_photo_url &&
                                <DeliveryPhoto url={transportsHistory?.proof_of_delivery_photo_url || ''} />
                            }
                        </div>
                        <div className={styles.transport_address}><AddressLine transportsHistory={transportsHistory} /></div>
                    </div>
                    <div className={styles.more_data}>
                        <div className={styles.more}>
                            {
                                !expanded &&
                                <Button classes={{ root: styles.more_root }} onClick={() => { openHandler(transportsHistory.transport_id) }}>
                                    <img src="/expand_more_black.png" alt="" width={24} height={24} />
                                </Button>
                            }
                        </div>
                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails
                classes={{
                    root: styles.Mui_accordion_details_root
                }}>
                <TransportHistoryDetail transportsHistory={transportsHistory} />
            </AccordionDetails>
            <div className={styles.less} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                {
                    expanded &&
                    <Button onClick={() => { setExpanded(false) }}>
                        <img src="/expand_more_black.png" alt="" width={24} height={24} />
                    </Button>
                }
            </div>
        </Accordion>
    )
    // modified by Bearer Web Developer end
});
export default TransportHistory;